<template>
  <div class="point-page">
    <div class="point-card">
      <div class="point-label">{{ $t('message.home.myPoint') }}</div>
      <div class="point-value">{{ memberPoint }}</div>
    </div>
    <div class="section-title">{{ $t('message.home.pointHistory') }}</div>
    <el-table :data="list" v-loading="loading" stripe>
      <el-table-column :label="$t('message.home.time')" prop="createdTime" width="180" />
      <el-table-column :label="$t('message.home.type')" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="row.credit > 0 ? 'success' : 'danger'" size="small">
            {{ row.credit > 0 ? '+' + row.credit : '-' + row.debit }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('message.home.balance')" prop="balance" width="120" />
      <el-table-column :label="$t('message.home.remark')" prop="remark" />
    </el-table>
    <el-pagination v-if="total > 0" background layout="prev, pager, next"
      :total="total" :page-size="queryParams.pageSize"
      @current-change="(p) => { queryParams.pageNumber = p; loadData() }"
      style="margin-top:20px;text-align:center" />
  </div>
</template>

<script>
import { list } from '@/api/upms/point'
import { load_member } from '@/api/upms/profile'

export default {
  name: 'MyPoint',
  data() {
    return {
      loading: false, memberPoint: 0, list: [], total: 0,
      queryParams: { pageNumber: 1, pageSize: 15 }
    }
  },
  created() {
    load_member().then(r => { this.memberPoint = r.data?.data?.member?.point ?? 0 })
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      list(this.queryParams).then(r => {
        const data = r.data?.data || r.data || {}
        this.list = data.content || data.list || []
        this.total = data.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.point-card {
  background: var(--theme-primary, var(--color-main, #4d6bfe));
  color: #fff;
  border-radius: 12px;
  padding: 24px 32px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.point-label { font-size: 14px; opacity: .85; }
.point-value { font-size: 42px; font-weight: bold; }
.section-title { font-size: 16px; font-weight: bold; margin-bottom: 16px; color: #303133; }
</style>
